import React, { useState, useEffect, useCallback } from 'react';
import { getAutoBlockHistory } from '../../../services/fail2banApi';

function fmt(ts) {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('pt-BR');
}

function eventBadge(type) {
  if (type === 'banned') return <span className="ab-badge ab-badge-warn">banido</span>;
  if (type === 'dry_run') return <span className="ab-badge ab-badge-info">dry-run</span>;
  if (type === 'unbanned') return <span className="ab-badge ab-badge-ok">unbanido</span>;
  if (type === 'expired') return <span className="ab-badge">expirado</span>;
  if (type === 'whitelisted') return <span className="ab-badge ab-badge-ok">whitelist</span>;
  if (type === 'reconciled') return <span className="ab-badge">reconciled</span>;
  return <span className="ab-badge">{type}</span>;
}

function AutoBlockHistoryTable({ refreshKey }) {
  const [events, setEvents] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterIp, setFilterIp] = useState('');
  const [filterType, setFilterType] = useState('');
  const [error, setError] = useState(null);

  const load = useCallback(async (reset = false) => {
    setLoading(true);
    setError(null);
    try {
      const params = { limit: 50 };
      if (!reset && cursor) params.cursor = cursor;
      if (filterIp) params.ip = filterIp.trim();
      if (filterType) params.event_type = filterType;
      const data = await getAutoBlockHistory(params);
      const newEvents = data.events || [];
      setEvents(reset ? newEvents : [...events, ...newEvents]);
      setCursor(data.next_cursor);
      setHasMore(!!data.next_cursor);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao carregar histórico');
    } finally {
      setLoading(false);
    }
  }, [cursor, filterIp, filterType, events]);

  useEffect(() => {
    setCursor(null);
    load(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  const applyFilters = () => {
    setCursor(null);
    load(true);
  };

  return (
    <div className="ab-history">
      <div className="ab-history-filters">
        <input
          type="text"
          placeholder="Filtrar por IP"
          value={filterIp}
          onChange={(e) => setFilterIp(e.target.value)}
        />
        <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
          <option value="">Todos os eventos</option>
          <option value="banned">Banidos</option>
          <option value="dry_run">Dry-run</option>
          <option value="unbanned">Desbanidos</option>
          <option value="expired">Expirados</option>
          <option value="whitelisted">Whitelisted</option>
          <option value="reconciled">Reconciliados</option>
        </select>
        <button type="button" onClick={applyFilters} disabled={loading}>
          {loading ? 'Carregando...' : 'Filtrar'}
        </button>
      </div>

      {error && <div className="ab-form-error">{error}</div>}

      <div className="ab-history-table-wrap">
        <table className="ab-history-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Evento</th>
              <th>IP</th>
              <th>Jail</th>
              <th>Nível</th>
              <th>Bantime</th>
              <th>Banido em</th>
              <th>Desbanido em</th>
              <th>Motivo</th>
              <th>Por</th>
            </tr>
          </thead>
          <tbody>
            {events.length === 0 && !loading && (
              <tr>
                <td colSpan="10" className="ab-history-empty">
                  Nenhum evento encontrado.
                </td>
              </tr>
            )}
            {events.map((ev) => (
              <tr key={ev.id}>
                <td>{ev.id}</td>
                <td>{eventBadge(ev.event_type)}</td>
                <td className="ab-history-ip">{ev.ip}</td>
                <td>{ev.jail}</td>
                <td>{ev.escalation_level || '—'}</td>
                <td>{ev.bantime_applied_seconds ? `${ev.bantime_applied_seconds}s` : '—'}</td>
                <td>{fmt(ev.banned_at)}</td>
                <td>{fmt(ev.unbanned_at)}</td>
                <td>{ev.unban_reason || '—'}</td>
                <td>{ev.unbanned_by || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {hasMore && (
        <div className="ab-history-loadmore">
          <button type="button" onClick={() => load(false)} disabled={loading}>
            {loading ? 'Carregando...' : 'Carregar mais 50'}
          </button>
        </div>
      )}
    </div>
  );
}

export default AutoBlockHistoryTable;
